import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme'; // HACK: This weird wrapper is purely to ensure that we don't pass the extra props
// down to the underlying div. If we upgraded styled-components to support either
// transient props or the ignoreProps api we could use that, but sadly our repackage
// does not support it.

const Div = (_ref) => {
  let rest = _objectWithoutPropertiesLoose(_ref, ["shouldHighlight", "shouldOffsetRight"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
};

const ResizeAffordance = styled(Div).withConfig({
  displayName: "ResizeAffordance",
  componentId: "sc-12q5exa-0"
})(["border-right:2px solid ", ";background:none;width:10px;height:100%;cursor:col-resize;position:relative;right:", "px;", " &:hover{border-color:", ";}"], TABLE_BORDER_COLOR, ({
  shouldOffsetRight
}) => shouldOffsetRight ? -1 : 0, ({
  shouldHighlight
}) => shouldHighlight ? `border-color: ${CALYPSO};` : '', CALYPSO);
export default ResizeAffordance;